import { all, fork, put, select, takeLatest, delay } from 'redux-saga/effects';
import {
  ACTION_REQUEST_SWAP_POINT_FOR_CRYPTO,
  REQUEST_SWAP_POINT_FOR_CRYPTO_SUCCESS,
  REQUEST_SWAP_POINT_FOR_CRYPTO_FAILURE,
  swapPointForCryptoAPI,
  ACTION_REQUEST_CALCULATE_POINT_TO_TOKEN,
  REQUEST_CALCULATE_POINT_TO_TOKEN_FAILURE,
  calculatePointToTokenAPI,
  checkTrustLineAPI,
  REQUEST_CHECK_TRUST_LINE_FAILURE,
  ACTION_CHECK_TRUST_LINE,
} from './index';
import { showToastAlert } from '../app';
import { getErrorMessage, isUnauthorized } from '../../../utils/error';
import { LOGOUT_ACTION } from '../auth';
import { fetchWalletAPI } from '../profile';
import { goToPage, ROUTE_TRANSACTION_MANAGEMENT } from '../routing';

function* loadSwapPointData() {
  yield put(fetchWalletAPI());
}

function* swapPointForCrypto() {
  yield takeLatest([ACTION_REQUEST_SWAP_POINT_FOR_CRYPTO], function* () {
    const { swapPointForCrypto } = yield select();
    const { requestBodySwap } = swapPointForCrypto;
    yield put(swapPointForCryptoAPI(requestBodySwap));
  });

  yield takeLatest([REQUEST_SWAP_POINT_FOR_CRYPTO_SUCCESS], function* () {
    yield put(showToastAlert('Swap point successfully!', 'success'));
    yield put(goToPage(ROUTE_TRANSACTION_MANAGEMENT));
  });

  yield takeLatest([REQUEST_SWAP_POINT_FOR_CRYPTO_FAILURE], function* (action) {
    const errorMessage = getErrorMessage(action.payload);

    yield put(
      showToastAlert(errorMessage || action.error || 'Failed to calculate point!', 'error')
    );

    yield delay(1000);

    if (isUnauthorized(action.payload))
      yield put({
        type: LOGOUT_ACTION,
      });
  });
}

function* calculatePointToToken() {
  yield takeLatest([ACTION_REQUEST_CALCULATE_POINT_TO_TOKEN], function* () {
    const { swapPointForCrypto } = yield select();
    const { requestBodySwap } = swapPointForCrypto;

    yield put(
      calculatePointToTokenAPI({
        pointAmount: requestBodySwap?.pointAmount,
        network: requestBodySwap?.network,
      })
    );
  });

  yield takeLatest([REQUEST_CALCULATE_POINT_TO_TOKEN_FAILURE], function* (action) {
    const errorMessage = getErrorMessage(action.payload);

    yield put(
      showToastAlert(errorMessage || action.error || 'Failed to calculate point!', 'error')
    );

    yield delay(2000);

    if (isUnauthorized(action.payload))
      yield put({
        type: LOGOUT_ACTION,
      });
  });
}

function* handleCheckTrustLine() {
  yield takeLatest([ACTION_CHECK_TRUST_LINE], function* (action) {
    yield put(checkTrustLineAPI(action.payload));
  });

  yield takeLatest([REQUEST_CHECK_TRUST_LINE_FAILURE], function* (action) {
    yield put(
      showToastAlert(getErrorMessage(action.payload) || `Failed to check trust line`, 'error')
    );
  });
}

export function* loadSwapPointForCryptoPage() {
  yield all([fork(loadSwapPointData), fork(swapPointForCrypto), fork(calculatePointToToken), fork(handleCheckTrustLine)]);
}
